(() => {
  const SELECTORS = {
    variantPickerRoot: "[data-variant-picker]",
  };

  const DEBUG = true;
  const POPUP_VERSION = "2026-05-25-medical-hard";
  // eslint-disable-next-line no-console
  console.log(
    "%c[size-popup] " + POPUP_VERSION,
    "background:#f0527c;color:#fff;font-weight:700;padding:4px 8px;border-radius:4px",
    { href: location?.href }
  );

  const dbg = (...args) => {
    // eslint-disable-next-line no-console
    console.log("[size-popup]", ...args);
  };

  if (typeof window !== "undefined" && typeof window.szymonTest !== "function") {
    window.szymonTest = () => {};
  }

  const STATE = {
    dialog: null,
    style: null,
    activeRequestId: 0,
  };

  const TEXT = {
    title: "Zobacz buty dostępne od ręki w twoim rozmiarze",
    lead: "Jeśli nie mamy od ręki tego czego szukasz, chętnie zrobimy dla Ciebie te buty na zamówienie :-)",
    loading: "Ładowanie…",
    empty: "Brak dostępnych produktów w tym rozmiarze.",
    addToCart: "Dodaj do koszyka",
    viewMore: "Zobacz więcej",
    found: (size) => `Znaleźliśmy produkty w rozmiarze ${size}.`,
    notFound: (size) => `Nie mamy teraz produktów od ręki w rozmiarze ${size}.`,
    fetchFailed: "Nie udało się pobrać listy produktów. Spróbuj ponownie za chwilę.",
  };

  const PRODUCT_JSON_CACHE = new Map();

  function normalizeTitle(title) {
    return (title || "").trim();
  }

  function parseSizeOptionTitles(value) {
    return (value || "")
      .split(",")
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean);
  }

  function normalizeOptionName(input) {
    if (typeof input === "string") return input.trim().toLowerCase();
    if (input && typeof input === "object" && typeof input.name === "string") return input.name.trim().toLowerCase();
    if (input === null || input === undefined) return "";
    return String(input).trim().toLowerCase();
  }

  function findSizeOptionIndex(productOptions, sizeOptionTitles) {
    if (!Array.isArray(productOptions) || !productOptions.length) return -1;
    if (!Array.isArray(sizeOptionTitles) || !sizeOptionTitles.length) return -1;

    const lowered = productOptions.map((n) => normalizeOptionName(n));
    for (let i = 0; i < lowered.length; i++) {
      const opt = lowered[i];
      if (sizeOptionTitles.some((t) => opt === t || opt.includes(t))) return i;
    }
    return -1;
  }

  function getMoneyFormat() {
    return window?.MinimogSettings?.money_format || "{{amount}}";
  }

  function formatPrice(cents) {
    if (typeof window.formatMoney === "function") return window.formatMoney(cents, getMoneyFormat());
    const n = Number(cents || 0) / 100;
    return n.toLocaleString(undefined, { style: "currency", currency: window?.Shopify?.currency?.active || "PLN" });
  }

  function getVariantStockFromPicker(pickerEl, variantId) {
    const list = pickerEl?.variantData;
    if (!Array.isArray(list) || !variantId) return null;
    const v = list.find((x) => Number(x?.id) === Number(variantId));
    if (!v) return null;
    return {
      available: v.available,
      inventory_management: v.inventory_management,
      inventory_quantity: v.inventory_quantity,
      inventory_policy: v.inventory_policy,
    };
  }

  function getDomInStockNowFlag(pickerEl, selectedSize) {
    if (!pickerEl || selectedSize === null || selectedSize === undefined) return null;
    try {
      const value = String(selectedSize);
      const esc = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(value) : value.replace(/"/g, '\\"');
      const checkedRadio = pickerEl.querySelector(`input[type="radio"][value="${esc}"]:checked`);
      if (checkedRadio && checkedRadio.dataset && checkedRadio.dataset.instockNow) {
        return checkedRadio.dataset.instockNow === "1";
      }

      const selectOption = pickerEl.querySelector(`select option[value="${esc}"]:checked`);
      if (selectOption && selectOption.dataset && selectOption.dataset.instockNow) {
        return selectOption.dataset.instockNow === "1";
      }

      return null;
    } catch {
      return null;
    }
  }

  function isInStockNow(variant, pickerEl) {
    if (!variant) return false;

    const pickerStock = getVariantStockFromPicker(pickerEl, variant.id);
    const stock = pickerStock || variant;

    if (stock.available === false) return false;

    const invMgmt = stock.inventory_management;
    const invQty = Number(stock.inventory_quantity);
    if (invMgmt === "shopify" && Number.isFinite(invQty) && invQty <= 0) return false;

    // Some "made-to-order" variants have inventory_policy=continue without qty exposed on variant object.
    // If we can read policy and it's continue, treat as not in-stock-now.
    if (stock.inventory_policy === "continue" && invMgmt === "shopify" && !Number.isFinite(invQty)) return false;

    return true;
  }

  function sizeToNumber(value) {
    if (value === null || value === undefined) return Number.POSITIVE_INFINITY;
    const s = String(value).trim().replace(",", ".");
    const n = Number.parseFloat(s);
    return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
  }

  function sortBySizeAsc(a, b) {
    const na = sizeToNumber(a?.size);
    const nb = sizeToNumber(b?.size);
    if (na !== nb) return na - nb;
    return String(a?.title || "").localeCompare(String(b?.title || ""), "pl", { sensitivity: "base", numeric: true });
  }

  function ensureDialog() {
    if (STATE.dialog) return STATE.dialog;

    const dialog = document.createElement("dialog");
    dialog.className = "sf-size-av-popup";
    dialog.innerHTML = `
      <div class="sf-size-av-popup__header">
        <div class="sf-size-av-popup__heading">
          <h2 class="sf-size-av-popup__title"></h2>
          <p class="sf-size-av-popup__lead"></p>
          <p class="sf-size-av-popup__subtitle"></p>
        </div>
        <button class="sf-size-av-popup__close" type="button" aria-label="Close">×</button>
      </div>
      <div class="sf-size-av-popup__grid" role="list"></div>
    `;

    dialog.addEventListener("click", (e) => {
      if (e.target === dialog) dialog.close();
    });

    dialog.querySelector(".sf-size-av-popup__close")?.addEventListener("click", () => dialog.close());
    dialog.querySelector(".sf-size-av-popup__lead").textContent = TEXT.lead;

    document.body.appendChild(dialog);
    STATE.dialog = dialog;

    const style = document.createElement("style");
    style.textContent = `
      .sf-size-av-popup {
        width: min(1100px, calc(100vw - 32px));
        max-width: calc(100vw - 32px);
        margin: auto;
        border: 0;
        border-radius: 12px;
        padding: 0;
        box-shadow: 0 30px 120px rgba(0,0,0,.35);
        background: #fff;
      }
      .sf-size-av-popup {
        opacity: 0;
        transform: translateY(6px) scale(.98);
        transition: opacity .18s ease, transform .18s ease;
      }
      .sf-size-av-popup.is-open {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
      .sf-size-av-popup::backdrop { background: rgba(0,0,0,.45); }
      .sf-size-av-popup__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        padding: 18px 22px 10px;
      }
      .sf-size-av-popup__heading { min-width: 0; }
      .sf-size-av-popup__title {
        font-size: 22px;
        line-height: 1.15;
        font-weight: 700;
        margin: 0;
      }
      @media (min-width: 768px) {
        .sf-size-av-popup__title { font-size: 24px; }
      }
      .sf-size-av-popup__lead {
        margin: 6px 0 6px;
        color: rgba(0,0,0,.72);
        font-size: 13px;
        line-height: 1.25;
      }
      .sf-size-av-popup__close {
        width: 52px;
        height: 52px;
        border: 0;
        border-radius: 999px;
        background: transparent;
        font-size: 34px;
        line-height: 1;
        cursor: pointer;
        color: rgba(0,0,0,.45);
        margin: -10px -12px 0 0;
      }
      .sf-size-av-popup__close:hover { background: rgba(0,0,0,.06); color: rgba(0,0,0,.6); }
      .sf-size-av-popup__subtitle {
        margin: 0;
        padding: 0;
        color: rgba(0,0,0,.72);
        font-size: 13px;
      }
      .sf-size-av-popup__grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 16px;
        padding: 8px 22px 18px;
        max-height: min(70vh, 680px);
        overflow: auto;
      }
      @media (max-width: 900px) {
        .sf-size-av-popup__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
      }
      @media (max-width: 520px) {
        .sf-size-av-popup {
          width: calc(100vw - 24px);
          max-width: calc(100vw - 24px);
        }
        .sf-size-av-popup__header { padding: 18px 16px 10px; }
        .sf-size-av-popup__grid {
          display: flex;
          gap: 16px;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-snap-type: x mandatory;
          scroll-padding-inline-start: 16px;
          -webkit-overflow-scrolling: touch;
          padding: 8px 16px 18px;
          max-height: none;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .sf-size-av-popup__grid::-webkit-scrollbar { display: none; }
        .sf-size-av-popup__card {
          flex: 0 0 auto;
          width: min(78vw, 280px);
          scroll-snap-align: start;
        }
      }
      .sf-size-av-popup__card {
        display: grid;
        grid-template-rows: auto 1fr auto;
        gap: 10px;
        border: 0;
        border-radius: 0;
        overflow: hidden;
        background: #fff;
      }
      .sf-size-av-popup__img {
        aspect-ratio: 1 / 1;
        background: rgba(0,0,0,.03);
        position: relative;
      }
      .sf-size-av-popup__img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      .sf-size-av-popup__overlay {
        position: absolute;
        inset: 0;
        display: grid;
        place-items: center;
        opacity: 0;
        transition: opacity .15s ease;
        background: rgba(0,0,0,.28);
        padding: 14px;
      }
      .sf-size-av-popup__card:hover .sf-size-av-popup__overlay,
      .sf-size-av-popup__card:focus-within .sf-size-av-popup__overlay {
        opacity: 1;
      }
      .sf-size-av-popup__overlay-actions {
        width: min(260px, 100%);
        display: grid;
        gap: 10px;
      }
      .sf-size-av-popup__overlay-actions .sf-size-av-popup__btn { width: 100%; }

      .sf-size-av-popup__btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 42px;
        padding: 0 16px;
        border-radius: 999px;
        border: 1px solid transparent;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .02em;
        text-transform: uppercase;
        cursor: pointer;
        user-select: none;
        text-decoration: none;
        transition: transform .08s ease, background-color .12s ease, border-color .12s ease, color .12s ease, opacity .12s ease;
      }
      .sf-size-av-popup__btn:focus-visible {
        outline: 3px solid rgba(240, 82, 124, .35);
        outline-offset: 2px;
      }
      .sf-size-av-popup__btn:active { transform: translateY(1px); }
      .sf-size-av-popup__btn[disabled] {
        opacity: .6;
        cursor: not-allowed;
        transform: none;
      }
      .sf-size-av-popup__btn--primary {
        background: #f0527c;
        border-color: #f0527c;
        color: #fff;
      }
      .sf-size-av-popup__btn--primary:hover { background: #e74873; border-color: #e74873; }
      .sf-size-av-popup__btn--secondary {
        background: #ffffff;
        border-color: rgba(0,0,0,.12);
        color: #73C0CA;
      }
      .sf-size-av-popup__btn--secondary:hover { background: rgba(255,255,255,.92); border-color: rgba(0,0,0,.18); }
      .sf-size-av-popup__meta {
        padding: 0;
        display: grid;
        gap: 4px;
      }
      .sf-size-av-popup__product-title {
        font-size: 13px;
        line-height: 1.25;
        font-weight: 600;
        color: rgba(0,0,0,.86);
        margin: 0;
      }
      .sf-size-av-popup__price {
        font-size: 13px;
        color: rgba(0,0,0,.72);
        margin-top: 6px;
        margin-bottom: 6px;
      }
      .sf-size-av-popup__size-badge {
        border: 1px solid #73c0ca;
        border-radius: 5px;
        height: 38px;
        width: 38px;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        margin-bottom: 5px;
        color: #73c0ca;
        font-size: 12px;
        line-height: 1;
      }
      .sf-size-av-popup__ver {
        font-weight: 100;
        color: rgba(0,0,0,.7);
        display: inline-block;
        margin-bottom: 4px;
      }
    `;
    document.head.appendChild(style);
    STATE.style = style;

    return dialog;
  }

  function setDialogLoading(dialog, title, subtitle) {
    dialog.querySelector(".sf-size-av-popup__title").textContent = title || "";
    dialog.querySelector(".sf-size-av-popup__subtitle").textContent = subtitle || "";
    const grid = dialog.querySelector(".sf-size-av-popup__grid");
    grid.innerHTML = "";
    const skeleton = document.createElement("div");
    skeleton.style.gridColumn = "1 / -1";
    skeleton.style.padding = "14px 0";
    skeleton.style.color = "rgba(0,0,0,.7)";
    skeleton.textContent = TEXT.loading;
    grid.appendChild(skeleton);
  }

  function setDialogItems(dialog, items) {
    const grid = dialog.querySelector(".sf-size-av-popup__grid");
    grid.innerHTML = "";

    if (!items.length) {
      const empty = document.createElement("div");
      empty.style.gridColumn = "1 / -1";
      empty.style.padding = "14px 0";
      empty.style.color = "rgba(0,0,0,.7)";
      empty.textContent = TEXT.empty;
      grid.appendChild(empty);
      return;
    }

    items.forEach((item) => {
      const card = document.createElement("div");
      card.className = "sf-size-av-popup__card";
      card.setAttribute("role", "listitem");

      const imgWrap = document.createElement("div");
      imgWrap.className = "sf-size-av-popup__img";
      const img = document.createElement("img");
      img.loading = "lazy";
      img.alt = item.title;
      img.src = item.image || "";
      imgWrap.appendChild(img);

      const overlay = document.createElement("div");
      overlay.className = "sf-size-av-popup__overlay";
      const overlayActions = document.createElement("div");
      overlayActions.className = "sf-size-av-popup__overlay-actions";

      const meta = document.createElement("div");
      meta.className = "sf-size-av-popup__meta";

      if (item.ver) {
        const ver = document.createElement("span");
        ver.className = "ver sf-size-av-popup__ver";
        ver.textContent = String(item.ver);
        meta.appendChild(ver);
      }

      const t = document.createElement("p");
      t.className = "sf-size-av-popup__product-title";
      t.textContent = item.title;
      const price = document.createElement("div");
      price.className = "sf-size-av-popup__price";
      price.textContent = formatPrice(item.price);
      meta.appendChild(t);
      meta.appendChild(price);

      if (item.size) {
        const sizeBadge = document.createElement("div");
        sizeBadge.className = "sf-size-av-popup__size-badge";
        sizeBadge.textContent = String(item.size);
        meta.appendChild(sizeBadge);
      }

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sf-size-av-popup__btn sf-size-av-popup__btn--primary";
      btn.textContent = TEXT.addToCart;
      btn.addEventListener("click", async () => {
        btn.setAttribute("disabled", "disabled");
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: [{ id: item.variantId, quantity: 1 }] }),
          });
          const data = await res.json();
          const added = data?.items?.[0] || data;
          if (window?.MinimogEvents?.emit) window.MinimogEvents.emit("ON_ITEM_ADDED", added);
          if (window?.Shopify?.onItemAdded) window.Shopify.onItemAdded(added);
          STATE.dialog?.close();
        } catch (e) {
          console.error(e);
        } finally {
          btn.removeAttribute("disabled");
        }
      });

      const link = document.createElement("a");
      link.href = item.url;
      link.className = "sf-size-av-popup__btn sf-size-av-popup__btn--secondary";
      link.textContent = TEXT.viewMore;

      overlayActions.appendChild(btn);
      overlayActions.appendChild(link);
      overlay.appendChild(overlayActions);
      imgWrap.appendChild(overlay);

      card.appendChild(imgWrap);
      card.appendChild(meta);
      grid.appendChild(card);
    });
  }

  async function fetchSuggestByTitle(title, limit = 10) {
    const qs = new URLSearchParams();
    qs.set("q", title);
    qs.set("resources[type]", "product");
    qs.set("resources[limit]", String(limit));
    qs.set("resources[options][fields]", "title");
    const res = await fetch(`/search/suggest.json?${qs.toString()}`, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`Suggest failed: ${res.status}`);
    const json = await res.json();
    const products = json?.resources?.results?.products || [];
    return products
      .map((p) => ({
        title: p?.title,
        handle: p?.handle,
        url: p?.url,
        image: p?.image,
      }))
      .filter((p) => p.handle && p.title);
  }

  async function fetchSuggestBySkuPrefix(skuPrefix, limit = 10) {
    const prefix = (skuPrefix || "").trim();
    if (!prefix) return [];
    const qs = new URLSearchParams();
    qs.set("q", prefix);
    qs.set("resources[type]", "product");
    qs.set("resources[limit]", String(limit));
    qs.set("resources[options][fields]", "variants.sku");
    qs.set("resources[options][unavailable_products]", "last");
    const res = await fetch(`/search/suggest.json?${qs.toString()}`, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`Suggest by SKU failed: ${res.status}`);
    const json = await res.json();
    const products = json?.resources?.results?.products || [];
    return products
      .map((p) => ({
        title: p?.title,
        handle: p?.handle,
        url: p?.url,
        image: p?.image,
      }))
      .filter((p) => p.handle && p.title);
  }

  async function fetchSearchBySkuPrefix(skuPrefix) {
    const prefix = (skuPrefix || "").trim();
    if (!prefix) return [];
    const qs = new URLSearchParams();
    qs.set("q", prefix);
    qs.set("type", "product");
    qs.set("view", "sku-json");
    qs.set("options[fields]", "variants.sku");
    qs.set("options[unavailable_products]", "last");
    const res = await fetch(`/search?${qs.toString()}`, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(`Search sku-json failed: ${res.status}`);
    const text = await res.text();
    let json;
    try {
      json = JSON.parse(text);
    } catch (e) {
      throw new Error(`Search sku-json parse failed: ${e?.message || e}`);
    }
    const products = Array.isArray(json?.products) ? json.products : [];

    for (const p of products) {
      if (!p?.handle) continue;
      if (PRODUCT_JSON_CACHE.has(p.handle)) continue;
      PRODUCT_JSON_CACHE.set(p.handle, Promise.resolve(p));
    }

    return products
      .map((p) => ({
        title: p?.title,
        handle: p?.handle,
        url: p?.url,
        image: p?.featured_image,
      }))
      .filter((p) => p.handle && p.title);
  }

  function extractProductHandleFromHref(href) {
    try {
      const u = new URL(href, location.origin);
      const parts = u.pathname.split("/").filter(Boolean);
      const productsIdx = parts.indexOf("products");
      if (productsIdx === -1) return null;
      return parts[productsIdx + 1] || null;
    } catch {
      return null;
    }
  }

  function getHandlesFromFeaturedCollectionsOnPage() {
    const sections = document.querySelectorAll('m-featured-collection[data-section-type="featured-collection"]');
    const handles = [];

    sections.forEach((sec) => {
      const links = sec.querySelectorAll('a[href*="/products/"]');
      links.forEach((a) => {
        const h = extractProductHandleFromHref(a.getAttribute("href") || "");
        if (h) handles.push(h);
      });
    });

    return Array.from(new Set(handles));
  }

  function getSkuPrefix(sku) {
    const s = (sku || "").trim();
    if (!s) return "";
    return s.slice(0, 4);
  }

  function getPrimarySkuFromProductJson(productJson) {
    const variants = productJson?.variants || [];
    const firstAvail = variants.find((v) => v?.available && v?.sku) || variants.find((v) => v?.sku) || null;
    return firstAvail?.sku || "";
  }

  async function fetchProductJson(handle) {
    const existing = PRODUCT_JSON_CACHE.get(handle);
    if (existing) return await existing;

    const p = fetch(`/products/${handle}.js`, { headers: { Accept: "application/json" } }).then(async (res) => {
      if (!res.ok) throw new Error(`Product JSON failed: ${res.status}`);
      return await res.json();
    });
    PRODUCT_JSON_CACHE.set(handle, p);
    return await p;
  }

  function prefetchFeaturedProducts() {
    try {
      const handles = getHandlesFromFeaturedCollectionsOnPage().slice(0, 24);
      if (!handles.length) return;

      const run = async () => {
        await mapWithConcurrency(
          handles,
          4,
          async (handle) => {
            try {
              await fetchProductJson(handle);
            } catch {
            }
            return null;
          },
          () => false
        );
      };

      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(() => run(), { timeout: 1500 });
      } else {
        setTimeout(() => run(), 400);
      }
    } catch (e) {
    }
  }

  async function mapWithConcurrency(items, concurrency, mapper, shouldStop) {
    const results = [];
    let idx = 0;

    const workers = Array.from({ length: Math.max(1, concurrency) }).map(async () => {
      while (idx < items.length) {
        if (shouldStop?.(results)) return;
        const current = items[idx++];
        const mapped = await mapper(current, results);
        if (mapped !== undefined && mapped !== null) results.push(mapped);
      }
    });

    await Promise.all(workers);
    return results;
  }

  function isProductJsonVariantInStockNow(v) {
    if (!v) return false;
    if (v.available === false) return false;

    const invQty = Number(v.inventory_quantity);

    if (Number.isFinite(invQty)) return invQty > 0;

    if (v.inventory_policy === "continue") return false;

    return true;
  }

  function pickVariantForSize(productJson, sizeIndex, sizeValue) {
    const variants = productJson?.variants || [];
    for (const v of variants) {
      if (!v || !Array.isArray(v.options)) continue;
      if (v.options[sizeIndex] !== sizeValue) continue;
      if (!isProductJsonVariantInStockNow(v)) continue;
      return v;
    }
    return null;
  }

  function extractFeatureVector(productJson) {
    const titleRaw = String(productJson?.title || "");
    const title = titleRaw.toLowerCase();
    const firstWordMatch = titleRaw.match(/^\s*([\p{L}]+)/u);
    const firstWord = firstWordMatch ? firstWordMatch[1].toLowerCase() : "";
    const rawTags = productJson?.tags;
    const tags = Array.isArray(rawTags)
      ? rawTags.map((t) => String(t).toLowerCase().trim())
      : typeof rawTags === "string"
      ? rawTags.toLowerCase().split(",").map((t) => t.trim()).filter(Boolean)
      : [];
    const tagSet = new Set(tags);
    const type = String(productJson?.type || "").toLowerCase().trim();

    let audience = null;
    if (/dziecięc|dla dzieci|dziecka|dziecko/.test(title)) audience = "kids";
    else if (/damsk/.test(title)) audience = "women";
    else if (/męsk/.test(title)) audience = "men";

    const categoryRules = [
      ["sandaly",  /\bsandał/],
      ["kapcie",   /\bkapci/],
      ["trzewiki", /\btrzewik/],
      ["adidasy",  /\badidas/],
      ["botki",    /\bbotk/],
      ["mokasyny", /\bmokasyn/],
      ["polbuty",  /\bpółbut/],
      ["trampki",  /\btrampk/],
    ];
    let category = null;
    for (const [name, rgx] of categoryRules) {
      if (rgx.test(title)) { category = name; break; }
    }

    const conditions = new Set();
    if (/płaskostop/.test(title)) conditions.add("plaskostopie");
    if (/koślaw.{0,5}kolan/.test(title)) conditions.add("koslawe_kolana");
    if (/koślawoś.{0,3}pięt/.test(title)) conditions.add("koslawosc_piety");
    if (/płasko.{0,3}koślaw/.test(title)) conditions.add("plasko_koslawe");
    if (/przywiedzion|chód.{0,5}gołębi/.test(title)) conditions.add("chod_golebi");
    if (/cukrzyc/.test(title)) conditions.add("cukrzyca");
    if (/do orte[zy]\b|\bortez/.test(title)) conditions.add("ortezy");

    const features = new Set();
    if (/thomas/.test(title)) features.add("thomas");
    if (/stabilizacj/.test(title)) features.add("stabilizacja_piety");
    if (/usztywnion/.test(title)) features.add("usztywniona_pieta");
    if (/supinacj/.test(title)) features.add("supinacja");

    let width = null;
    const wm = title.match(/tęgość\s+(f|g|h)\b/);
    if (wm) width = wm[1];

    const outsole = new Set();
    if (/vibram/.test(title)) outsole.add("vibram");
    if (/sportow.{0,5}podeszw/.test(title)) outsole.add("sportowa");
    if (/zimow.{0,5}podeszw/.test(title)) outsole.add("zimowa");
    if (/elastyczn.{0,5}podeszw/.test(title)) outsole.add("elastyczna");

    const closure = new Set();
    if (/\brzep/.test(title)) closure.add("rzepy");
    if (/sznurow/.test(title)) closure.add("sznurowane");
    if (/suwak/.test(title)) closure.add("suwak");
    if (/\bboa\b/i.test(productJson?.title || "")) closure.add("boa");

    const seasons = new Set();
    if (tagSet.has("letnie") || /letni/.test(title)) seasons.add("lato");
    if (tagSet.has("wiosenne") || tagSet.has("wiosene") || /wiosen/.test(title)) seasons.add("wiosna");
    if (tagSet.has("jesienne") || /jesien/.test(title)) seasons.add("jesien");
    if (tagSet.has("zimowe") || /zimow/.test(title)) seasons.add("zima");

    const isMedical =
      /^medyczn|\bortopedycz|do orte[zy]/.test(title) ||
      tagSet.has("med") ||
      tagSet.has("aurelkamed") ||
      type === "med" || type === "orto" || type === "do ortez";

    const isConfigurator = tagSet.has("konfigurator");

    return {
      firstWord,
      audience, category, conditions, features, width,
      outsole, closure, seasons, isMedical, isConfigurator, type,
    };
  }

  function scoreCandidate(curr, cand) {
    if (!curr || !cand) return 0;

    if (cand.isConfigurator) {
      if (DEBUG) dbg("HARD EXCLUDE: konfigurator");
      return null;
    }
    if (curr.isMedical !== cand.isMedical) {
      if (DEBUG) dbg("HARD EXCLUDE: isMedical", curr.isMedical, "!==", cand.isMedical);
      return null;
    }
    if (curr.isMedical && cand.isMedical && curr.firstWord && cand.firstWord && curr.firstWord !== cand.firstWord) {
      if (DEBUG) dbg("HARD EXCLUDE: medical firstWord", curr.firstWord, "!==", cand.firstWord);
      return null;
    }
    if (curr.audience && cand.audience && curr.audience !== cand.audience) {
      if (DEBUG) dbg("HARD EXCLUDE: audience", curr.audience, "!==", cand.audience);
      return null;
    }

    if (curr.conditions.size > 0 && cand.conditions.size > 0) {
      let overlap = false;
      for (const c of curr.conditions) if (cand.conditions.has(c)) { overlap = true; break; }
      if (!overlap) {
        if (DEBUG) dbg("HARD EXCLUDE: conditions", [...curr.conditions], "vs", [...cand.conditions]);
        return null;
      }
    }

    let s = 0;

    if (curr.type && cand.type) {
      if (curr.type === cand.type) s += 20;
      else s -= 15;
    }
    if (curr.firstWord && cand.firstWord && curr.firstWord === cand.firstWord) s += 10;

    if (curr.width && cand.width && curr.width === cand.width) s += 30;
    if (curr.category && cand.category && curr.category === cand.category) s += 25;
    for (const c of curr.conditions) if (cand.conditions.has(c)) s += 30;
    for (const f of curr.features) if (cand.features.has(f)) s += 15;
    for (const sea of curr.seasons) if (cand.seasons.has(sea)) s += 10;
    for (const o of curr.outsole) if (cand.outsole.has(o)) s += 5;
    for (const cl of curr.closure) if (cand.closure.has(cl)) s += 5;

    return s;
  }

  function getCardImage(productJson, variant) {
    const vfi = variant?.featured_image;
    if (vfi) {
      if (typeof vfi === "string" && vfi) return vfi;
      if (typeof vfi === "object" && typeof vfi.src === "string" && vfi.src) return vfi.src;
    }
    const pfi = productJson?.featured_image;
    if (pfi) {
      if (typeof pfi === "string" && pfi) return pfi;
      if (typeof pfi === "object" && typeof pfi.src === "string" && pfi.src) return pfi.src;
    }
    const images = productJson?.images;
    if (Array.isArray(images) && images.length > 0) {
      const first = images[0];
      if (typeof first === "string" && first) return first;
      if (typeof first === "object" && typeof first?.src === "string" && first.src) return first.src;
    }
    return "";
  }

  async function handleVariantChange(variant, pickerEl) {
    if (!pickerEl) return;
    const root = pickerEl.closest(SELECTORS.variantPickerRoot);
    if (!root) return;

    const currentTitle = normalizeTitle(root.dataset.productTitle);
    const currentHandle = root.dataset.productHandle;
    const sizeOptionTitles = parseSizeOptionTitles(root.dataset.sizeOptionTitles);

    const productOptions = pickerEl?.productData?.options || [];
    const sizeIndex = findSizeOptionIndex(productOptions, sizeOptionTitles);
    if (sizeIndex < 0) return;

    const selectedSize =
      Array.isArray(variant?.options) ? variant.options[sizeIndex] : Array.isArray(pickerEl?.options) ? pickerEl.options[sizeIndex] : null;
    if (!selectedSize) return;

    if (DEBUG) {
      dbg("Event variant", variant);
      dbg("Selected size", selectedSize);
      dbg("Picker variantData size", Array.isArray(pickerEl?.variantData) ? pickerEl.variantData.length : null);
      if (variant?.id) dbg("Picker stock for variant", getVariantStockFromPicker(pickerEl, variant.id));
      dbg("DOM instockNow flag", getDomInStockNowFlag(pickerEl, selectedSize));
    }

    const domFlag = getDomInStockNowFlag(pickerEl, selectedSize);
    const inStockNow = domFlag === null ? isInStockNow(variant, pickerEl) : domFlag;
    if (DEBUG) dbg("Decision isInStockNow =", inStockNow);
    if (inStockNow) return;

    const currentSkuPrefix = getSkuPrefix(
      variant?.sku || pickerEl?.currentVariant?.sku || pickerEl?.productData?.initialVariant?.sku
    );

    const requestId = ++STATE.activeRequestId;
    const dialog = ensureDialog();
    setDialogLoading(
      dialog,
      TEXT.title,
      ""
    );

    if (!dialog.open) {
      dialog.classList.remove("is-open");
      dialog.showModal();
      requestAnimationFrame(() => dialog.classList.add("is-open"));
    }

    try {
      const featuredHandles = getHandlesFromFeaturedCollectionsOnPage().filter((h) => h && h !== currentHandle);
      const candidateMap = new Map();
      for (const h of featuredHandles) candidateMap.set(h, { handle: h });

      if (currentSkuPrefix) {
        let gotFromSearch = false;
        try {
          const bySearch = await fetchSearchBySkuPrefix(currentSkuPrefix);
          if (requestId !== STATE.activeRequestId) return;
          if (DEBUG) dbg("Search sku-json returned", bySearch.length, "candidates");
          for (const p of bySearch) {
            if (p.handle && p.handle !== currentHandle && !candidateMap.has(p.handle)) {
              candidateMap.set(p.handle, p);
            }
          }
          gotFromSearch = bySearch.length > 0;
        } catch (e) {
          if (DEBUG) dbg("Search sku-json failed, falling back to suggest", e);
        }

        if (!gotFromSearch) {
          try {
            const bySku = await fetchSuggestBySkuPrefix(currentSkuPrefix, 10);
            if (requestId !== STATE.activeRequestId) return;
            for (const p of bySku) {
              if (p.handle && p.handle !== currentHandle && !candidateMap.has(p.handle)) {
                candidateMap.set(p.handle, p);
              }
            }
          } catch (e) {
            if (DEBUG) dbg("SKU suggest fallback failed", e);
          }
        }
      }

      if (candidateMap.size === 0) {
        try {
          const suggestions = await fetchSuggestByTitle(currentTitle, 20);
          if (requestId !== STATE.activeRequestId) return;
          const sameTitle = suggestions.filter((p) => normalizeTitle(p.title) === currentTitle);
          for (const p of sameTitle) {
            if (p.handle && p.handle !== currentHandle) candidateMap.set(p.handle, p);
          }
        } catch (e) {
          if (DEBUG) dbg("Title suggest failed", e);
        }
      }

      const candidates = Array.from(candidateMap.values());

      let currentFeatures = null;
      try {
        const currentPj = await fetchProductJson(currentHandle);
        if (requestId !== STATE.activeRequestId) return;
        currentFeatures = extractFeatureVector(currentPj);
        if (DEBUG) dbg("Current product features", currentFeatures);
      } catch (e) {
        if (DEBUG) dbg("Failed to load current product JSON", e);
      }

      const MAX_RESULTS = 8;
      const MAX_PROCESS = 60;
      const results = await mapWithConcurrency(
        candidates.slice(0, MAX_PROCESS),
        6,
        async (c) => {
          if (requestId !== STATE.activeRequestId) return null;
          try {
            const pj = await fetchProductJson(c.handle);
            if (currentSkuPrefix) {
              const pjSkuPrefix = getSkuPrefix(getPrimarySkuFromProductJson(pj));
              if (pjSkuPrefix && pjSkuPrefix !== currentSkuPrefix) return null;
            }
            const matched = pickVariantForSize(pj, sizeIndex, selectedSize);
            if (!matched) return null;

            const candFeatures = extractFeatureVector(pj);
            if (DEBUG) {
              dbg(
                "Candidate", c.handle,
                "title:", pj?.title,
                "firstWord:", candFeatures.firstWord,
                "vs curr:", currentFeatures?.firstWord
              );
            }
            const score = currentFeatures ? scoreCandidate(currentFeatures, candFeatures) : 0;
            if (DEBUG) dbg("→ score=", score);
            if (score === null) return null;

            const ver = getSkuPrefix(matched?.sku || getPrimarySkuFromProductJson(pj)) || null;
            return {
              title: pj.title,
              url: pj.url || c.url || `/products/${c.handle}`,
              image: getCardImage(pj, matched) || c.image,
              price: matched.price,
              variantId: matched.id,
              size: selectedSize,
              ver,
              score,
            };
          } catch (e) {
            return null;
          }
        },
        () => requestId !== STATE.activeRequestId
      );

      if (requestId !== STATE.activeRequestId) return;
      const finalResults = results
        .sort((a, b) => {
          const ds = (b.score ?? 0) - (a.score ?? 0);
          if (ds !== 0) return ds;
          return sortBySizeAsc(a, b);
        })
        .slice(0, MAX_RESULTS);
      if (DEBUG) dbg("Final results", finalResults.length, "of", results.length, "processed");
      dialog.querySelector(".sf-size-av-popup__subtitle").textContent = finalResults.length
        ? ""
        : TEXT.notFound(selectedSize);
      setDialogItems(dialog, finalResults);
    } catch (e) {
      if (requestId !== STATE.activeRequestId) return;
      dialog.close();
    }
  }

  function subscribeOnce(root) {
    const productId = root.dataset.productId;
    if (!productId) return false;
    if (root.dataset.sizePopupSubscribed === "true") return true;

    const picker = root.querySelector("variant-picker");
    if (picker && picker.dataset.sizePopupClickBound !== "true") {
      picker.dataset.sizePopupClickBound = "true";

      const isSizeOptionElement = (el) => {
        if (!el || typeof el.closest !== "function") return false;
        const wrapper = el.closest("[data-option-name]");
        if (!wrapper) return false;
        const optionName = String(wrapper.dataset.optionName || "").trim().toLowerCase();
        const sizeTitles = parseSizeOptionTitles(root.dataset.sizeOptionTitles);
        return sizeTitles.some((t) => optionName === t || optionName.includes(t));
      };

      const triggerForSize = () => {
        setTimeout(() => {
          const currentVariant =
            picker.currentVariant ||
            picker?.productData?.variants?.find((v) => v?.id === picker?.productData?.current_variant_id);
          handleVariantChange(currentVariant, picker);
        }, 0);
      };

      picker.addEventListener(
        "click",
        (e) => {
          const target = e.target;
          if (!isSizeOptionElement(target)) return;
          const isVariantHit = target.closest(
            'input[type="radio"], label[data-option-type], .variant-picker__option, .product-option-item, option[data-option-position]'
          );
          if (!isVariantHit) return;
          triggerForSize();
        },
        true
      );

      picker.addEventListener(
        "change",
        (e) => {
          if (!isSizeOptionElement(e.target)) return;
          triggerForSize();
        },
        true
      );
    }

    root.dataset.sizePopupSubscribed = "true";
    return true;
  }

  function init() {
    prefetchFeaturedProducts();
    const roots = document.querySelectorAll(SELECTORS.variantPickerRoot);
    roots.forEach((root) => subscribeOnce(root));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();